import request from "./request"
import store from "@/store"
import purchase from "@/api/drag/purchase"
import purchase_order from "@/api/drag/purchase_order"
import purchase_return from "@/api/drag/purchase_return"
import sale from "@/api/drag/sale"
import sale_order from "@/api/drag/sale_order"
import sale_return from "@/api/drag/sale_return"
import assembly from "@/api/drag/assembly"
// - 调拨单 dispatch
// - 盘点单 inventory
// - 其他入库 other_in
// - 其他出库 other_out
// - 入库单 stock_in
// - 出库单stock_out
// label
import label from "@/api/drag/label"
import dispatch from "@/api/drag/dispatch"
import inventory from "@/api/drag/inventory"
import other_in from "@/api/drag/other_in"
import other_out from "@/api/drag/other_out"
import stock_in from "@/api/drag/stock_in"
import stock_out from "@/api/drag/stock_out"

console.log(JSON.stringify(purchase))
export const getPrintElementTypeGroup = () => request.get(store.getters.sourceUrl)
export const getPrintElementTypeGroup2 = async () => {

    if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/purchase") {
        return {
            data: purchase
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/purchase_order") {
        return {
            data: purchase_order
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/purchase_return") {
        return {
            data: purchase_return
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/sale") {
        return {
            data: sale
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/sale_order") {
        return {
            data: sale_order
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/sale_return") {
        return {
            data: sale_return
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/assembly") {
        return {
            data: assembly
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/label") {
        return {
            data: label
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/dispatch") {
        return {
            data: dispatch
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/inventory") {
        return {
            data: inventory
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/other_in") {
        return {
            data: other_in
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/other_out") {
        return {
            data: other_out
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/stock_in") {
        return {
            data: stock_in
        }
    } else if (store.getters.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/stock_out") {
        return {
            data: stock_out
        }
    }
    else {
        return {
            data: purchase
        }
    }
}
// /hiPrint/getTemplateContentById/
export const getTemplateContentById = (id) => request.get(`/hiPrint/getTemplateContentById/${id}`)
// /api/hiPrint/updateTemplateContentById {content,id}
export const updateTemplateContentById = (data) => request.post(`/hiPrint/updateTemplateContentById`, data)